interface ReadInput {
  status: 'idle' | 'pending' | 'ready' | 'failed';
  message: string; canRetry: boolean;
}
export interface ArtifactReadPresentation {
  showFeedback: boolean; pending: boolean; message: string; canRetry: boolean;
}
const readStates = new Map([
  ['idle', { showFeedback: false, pending: false }],
  ['ready', { showFeedback: false, pending: false }],
  ['pending', { showFeedback: true, pending: true }],
  ['failed', { showFeedback: true, pending: false }],
]);

/** Read ownership stays in the application; this is only its workbench projection. */
export const selectArtifactReadPresentation = (state: ReadInput): ArtifactReadPresentation => {
  const projection = readStates.get(state.status);
  if (!projection) throw new TypeError('Artifact read status required');
  return { ...projection, message: state.message, canRetry: state.status === 'failed' && state.canRetry };
};
